<template>
  <div class="spm-root">
    <div v-if="loading" class="spm-loading-overlay">
      <span class="spm-loading-text">加载中...</span>
    </div>
    <div v-show="!loading" class="spm-page">
      <component
        v-for="item in visibleComponents"
        :key="item.uniqueKey"
        :is="componentMap[item.componentKey]"
        :ref="item.refName"
        :component-id="item.componentId"
      />
    </div>
  </div>
</template>

<script>
import { fetchSpecialInfo } from '../../api/special';
import viewportMixin from '../mobile/mixins/viewport';

// 移动端 PageHeader / PageFooter
import PageHeader from '../home/components/AppHeader.vue';

// SpecialOne 移动端组件
import SpOneTopBanner from './SpecialOne/components/TopBanner.vue'
import SpOneHeroCarousel from './SpecialOne/components/HeroCarousel.vue'
import SpOneHeroCarouselPanel from './SpecialOne/components/HeroCarouselPanel.vue'
import SpOneEventSeries from './SpecialOne/components/EventSeries.vue'
import SpOneHighlightsGrid from './SpecialOne/components/HighlightsGrid.vue'
import SpOneGuestShowcase from './SpecialOne/components/GuestShowcase.vue'
import SpOneAgendaSection from './SpecialOne/components/AgendaSection.vue'
import SpOneAddressSection from './SpecialOne/components/AddressSection.vue'
import SpOneHostSection from './SpecialOne/components/HostSection.vue'
import SpOneCoreActivities from './SpecialOne/components/CoreActivities.vue'
import SpOneReviewSection from './SpecialOne/components/ReviewSection.vue'
import SpOneReviewGala from './SpecialOne/components/ReviewGala.vue'
import SpOneOrganizations from './SpecialOne/components/Organizations.vue'
import SpOnePartners from './SpecialOne/components/Partners.vue'
import SpOneMediaCooperation from './SpecialOne/components/MediaCooperation.vue'
import SpOneSpecialTitle from './SpecialOne/components/SpecialOneTitle.vue'

// SpecialSix 移动端组件
import SpSixHeroBanner from './SpecialSix/components/HeroBanner.vue'
import SpSixHeroSection from './SpecialSix/components/HeroSection.vue'
import SpSixNewsSection from './SpecialSix/components/NewsSection.vue'
import SpSixPartnerSection from './SpecialSix/components/PartnerSection.vue'
import SpSixCultivationSection from './SpecialSix/components/CultivationSection.vue'
import SpSixStorySection from './SpecialSix/components/StorySection.vue'
import SpSixTitle from './SpecialSix/components/SpecialSixTitle.vue'
import SpImage from './components/SpImage.vue'
import SpText from './components/SpText.vue'
import SpTwoModule1 from './SpecialTwo/components/SpTwoModule1.vue'
import SpTwoModule2 from './SpecialTwo/components/SpTwoModule2.vue'
import SpTwoModule3 from './SpecialTwo/components/SpTwoModule3.vue'
import SpTwoModule4 from './SpecialTwo/components/SpTwoModule4.vue'
import SpTwoModule5 from './SpecialTwo/components/SpTwoModule5.vue'
import SpTwoModule6 from './SpecialTwo/components/SpTwoModule6.vue'

// SpecialThree 移动端组件
import SpThreeModule1 from './SpecialThree/components/SpThreeModule1.vue'
import SpThreeModule2 from './SpecialThree/components/SpThreeModule2.vue'
import SpThreeModule3 from './SpecialThree/components/SpThreeModule3.vue'

const componentMap = {
  header: PageHeader,

  // SpecialOne
  sp_one_module_1: SpOneTopBanner,
  sp_one_module_2: SpOneHeroCarousel,
  sp_one_module_3: SpOneHeroCarouselPanel,
  sp_one_module_4: SpOneEventSeries,
  sp_one_module_5: SpOneHighlightsGrid,
  sp_one_module_6: SpOneGuestShowcase,
  sp_one_module_7: SpOneAgendaSection,
  sp_one_module_8: SpOneAddressSection,
  sp_one_module_9: SpOneHostSection,
  sp_one_module_10: SpOneCoreActivities,
  sp_one_module_11: SpOneReviewSection,
  sp_one_module_12: SpOneReviewGala,
  sp_one_module_13: SpOneOrganizations,
  sp_one_module_14: SpOnePartners,
  sp_one_module_15: SpOneMediaCooperation,
  sp_one_title: SpOneSpecialTitle,

  // SpecialSix
  sp_six_module_1: SpSixHeroBanner,
  sp_six_module_2: SpSixHeroSection,
  sp_six_module_3: SpSixNewsSection,
  sp_six_module_4: SpSixPartnerSection,
  sp_six_module_5: SpSixCultivationSection,
  sp_six_module_6: SpSixStorySection,
  sp_six_title: SpSixTitle,

  // 通用组件
  sp_image: SpImage,
  sp_txt: SpText,

  // SpecialTwo
  sp_two_module_1: SpTwoModule1,
  sp_two_module_2: SpTwoModule2,
  sp_two_module_3: SpTwoModule3,
  sp_two_module_4: SpTwoModule4,
  sp_two_module_5: SpTwoModule5,
  sp_two_module_6: SpTwoModule6,

  // SpecialThree
  sp_three_module_1: SpThreeModule1,
  sp_three_module_2: SpThreeModule2,
  sp_three_module_3: SpThreeModule3
}

export default {
  name: 'SpecialMobilePage',
  mixins: [viewportMixin],
  data() {
    return {
      loading: true,
      specialName: '',
      templateKey: '',
      componentList: [],
      componentMap
    }
  },
  computed: {
    visibleComponents() {
      const countMap = {}
      return (this.componentList || [])
        .filter(item => item.isValid === 1 && componentMap[item.componentKey])
        .map(item => {
          const baseId = item.componentCode || item.componentKey
          const count = countMap[baseId] || 0
          countMap[baseId] = count + 1
          const suffix = count === 0 ? '' : `_${count}`
          return {
            ...item,
            uniqueKey: `${baseId}_${count}`,
            refName: `${baseId}${suffix}`,
            componentId: `${baseId}${suffix}`
          }
        })
    }
  },
  mounted() {
    this.loadSpecialInfo()
  },
  methods: {
    async loadSpecialInfo() {
      const specialCode = this.$route.query.specialCode || this.$route.params.specialCode
      if (!specialCode) {
        this.$router.replace({ name: 'not-found' })
        return
      }
      try {
        const data = await fetchSpecialInfo(specialCode)
        if (!data.componentList || !Array.isArray(data.componentList)) {
          this.$router.replace({ name: 'not-found' })
          return
        }
        this.specialName = data.specialName || ''
        this.templateKey = data.templateKey || ''
        this.componentList = data.componentList
        await this.loadTemplateCss(this.templateKey)
        this.$nextTick(() => {
          this.applyConfigs()
          this.loading = false
        })
      } catch (error) {
        console.error('getSpecialInfo error', error)
        this.$router.replace({ name: 'not-found' })
      }
    },
    async loadTemplateCss(templateKey) {
      try {
        if (templateKey === 'template_1') {
          await import('./SpecialOne/assets/index.css')
        } else if (templateKey === 'template_6') {
          await import('./SpecialSix/assets/index.css')
        }
      } catch (e) {
        console.warn('load template css error', e)
      }
    },
    applyConfigs() {
      this.visibleComponents.forEach(item => {
        if (item.componentKey === 'header' || item.componentKey === 'bottom') return
        const component = this.$refs[item.refName]
        if (!component || !item.configJson) return
        const target = Array.isArray(component) ? component[0] : component
        let config = {}
        try {
          config = JSON.parse(item.configJson)
        } catch (e) {
          console.warn(`component ${item.componentKey} configJson parse error`, e)
          return
        }
        Object.keys(config).forEach(key => {
          if (key in target.$data) {
            target.$data[key] = config[key]
          }
        })
      })
    }
  }
}
</script>

<style scoped>
.spm-root {
  min-height: 100vh;
  background: #fff;
  width: 100%;
  max-width: 750px;
  margin: 0 auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
}

.spm-page {
  width: 100%;
  margin: 0 auto;
}

.spm-page img {
  max-width: 100%;
  height: auto;
}

/* 强制专题页内的公共头部按移动端尺寸渲染，避免 804px 设计稿尺寸溢出 */
.spm-root >>> .app-header,
.spm-root >>> .app-header__top-bar,
.spm-root >>> .app-header__logo-row,
.spm-root >>> .app-header__nav-wrapper,
.spm-root >>> .app-header__nav-scroll {
  width: 100% !important;
}

.spm-root >>> .app-header__top-bar {
  height: 40px;
}

.spm-root >>> .app-header__top-text {
  font-size: 13px;
  line-height: 20px;
  margin-left: 12px;
}

.spm-root >>> .app-header__logo-row {
  height: 60px;
  padding: 0 12px;
}

.spm-root >>> .app-header__logo {
  width: 110px;
  height: 36px;
}

.spm-root >>> .app-header__search {
  flex: 1;
  max-width: 220px;
  height: 36px;
  margin-left: 12px;
}

.spm-root >>> .app-header__search-icon {
  width: 20px;
  height: 20px;
  margin-left: 10px;
}

.spm-root >>> .app-header__avatar {
  width: 36px;
  height: 36px;
}

.spm-root >>> .app-header__nav-wrapper {
  padding-top: 6px;
  padding-bottom: 4px;
}

.spm-root >>> .app-header__nav-scroll {
  padding: 0 8px 4px;
}

.spm-root >>> .app-header__nav-item {
  font-size: 15px;
  line-height: 36px;
  padding: 0 12px;
}

.spm-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
}

.spm-loading-text {
  color: rgba(0, 124, 68, 1);
  font-size: 16px;
  font-family: Microsoft YaHei-Bold;
  font-weight: 700;
}
</style>
